import { gql } from '@apollo/client'

export const ACTION_MUTATION = gql`
  mutation action($entityId: String!, $value: String!) {
    action(entityId: $entityId, value: $value)
  }
`
